import { css } from '@emotion/react';
import type { getInitialGitProvider } from 'utils/vcs.utils';
import { ReactComponent as RawHelmIcon } from 'assets/images/helm-logo-on-white.svg';
import styled from 'types/theme.types';
import { ReactComponent as RawBitbucketIcon } from 'assets/images/bitbucket.svg';
import { ReactComponent as RawGitlabIcon } from 'assets/images/gitlab.svg';
import { ReactComponent as RawGitIcon } from 'assets/images/git.svg';
import { ReactComponent as RawAzureDevOpsIcon } from 'assets/images/azure-devops.svg';
import { GithubOutlined } from '@ant-design/icons';

interface Props {
  providerName: ReturnType<typeof getInitialGitProvider>;
}

/* Sized rather than nudged: a margin pushes the glyph off the Avatar's own centring. */
const VcsIcon = ({ providerName }: Props) => {
  const github = <GithubIcon />;

  if (!providerName) return <GitIcon />;
  return {
    BitBucket: <CenteredBitbucketIcon />,
    BitBucketServer: <CenteredBitbucketIcon />,
    GitHub: github,
    GitHubEnterprise: github,
    GitLab: <CenteredGitlabIcon />,
    AzureDevOps: <CenteredAzureDevopsIcon />,
    HelmRepository: <CenteredHelmRepositoryIcon />,
    GitLabEnterprise: <CenteredGitlabIcon />,
    Other: <GitIcon />
  }[providerName];
};

export default VcsIcon;

const glyphSize = css`
  width: 16px;
  height: 16px;
`;

const CenteredBitbucketIcon = styled(RawBitbucketIcon)`
  ${glyphSize}
`;

const GithubIcon = styled(GithubOutlined)`
  font-size: 16px;
  color: var(--icon-primary-standalone);
`;

const CenteredGitlabIcon = styled(RawGitlabIcon)`
  ${glyphSize}
`;

const CenteredAzureDevopsIcon = styled(RawAzureDevOpsIcon)`
  ${glyphSize}
`;

const CenteredHelmRepositoryIcon = styled(RawHelmIcon)`
  ${glyphSize}
`;

const GitIcon = styled(RawGitIcon)`
  ${glyphSize}
`;
